module.exports = __webpack_public_path__ + "img/about-ch2-urbanproblems-inequality.a2945c01.svg";